/**
 * Size Drawer with Dynamic Price
 * Prices update based on currently selected options (e.g., thickness, color)
 */
(function () {
  const trigger = document.getElementById('sizeSelectorTrigger');
  const drawer = document.getElementById('sizeDrawer');
  const overlay = document.getElementById('sizeDrawerOverlay');
  const closeBtn = document.getElementById('sizeDrawerClose');
  const sizeDisplay = document.getElementById('selectedSizeDisplay');
  const sizeItems = document.querySelectorAll('.size-drawer .size-grid-item');

  if (!trigger || !drawer || !overlay || !closeBtn) return;

  let variants = [];
  let optionMeta = {};

  try {
    const variantDataEl = document.getElementById('SizeDrawerVariantData');
    if (variantDataEl) variants = JSON.parse(variantDataEl.textContent);

    const optionMetaEl = document.getElementById('SizeDrawerOptionMeta');
    if (optionMetaEl) optionMeta = JSON.parse(optionMetaEl.textContent);
  } catch (e) {
    console.error('Size Drawer: Failed to parse variant data', e);
  }

  const sizeOptionIndex = optionMeta.size_option_index || 0;
  const optionNames = optionMeta.option_names || [];

  function getOtherSelectedOptions() {
    const selected = {};

    optionNames.forEach(function (name, index) {
      if (index === sizeOptionIndex) return;

      const handleName = name.toLowerCase().replace(/[^a-z0-9]+/g, '-');
      const checkedRadio = document.querySelector('input[name="' + handleName + '"]:checked');

      if (checkedRadio) {
        selected[index] = checkedRadio.value;
      }
    });

    return selected;
  }

  function findVariantForSize(sizeValue) {
    const otherOptions = getOtherSelectedOptions();

    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      var options = variant.options;

      if (options[sizeOptionIndex] !== sizeValue) continue;

      var allMatch = true;
      for (var idx in otherOptions) {
        if (options[parseInt(idx)] !== otherOptions[idx]) {
          allMatch = false;
          break;
        }
      }

      if (allMatch) return variant;
    }

    return null;
  }

  function updateSizePrices() {
    sizeItems.forEach(function (item) {
      var sizeValue = item.getAttribute('data-size-value');
      var priceEl = item.querySelector('.size-price');

      if (!priceEl || !sizeValue) return;

      var variant = findVariantForSize(sizeValue);

      if (variant) {
        priceEl.textContent = variant.price_formatted;
        priceEl.style.display = '';

        var label = item.querySelector('.size-grid-label');
        if (label) {
          if (variant.available) {
            label.classList.remove('disabled');
          } else {
            label.classList.add('disabled');
          }
        }
      } else {
        priceEl.textContent = '';
        priceEl.style.display = 'none';
      }
    });
  }

  function openDrawer() {
    updateSizePrices();
    drawer.classList.add('active');
    overlay.classList.add('active');
    document.body.classList.add('drawer-open');
  }

  function closeDrawer() {
    drawer.classList.remove('active');
    overlay.classList.remove('active');
    document.body.classList.remove('drawer-open');
  }

  function updateBorders() {
    sizeItems.forEach(function (item) {
      var radio = item.querySelector('input[type="radio"]');
      if (radio && radio.checked) {
        item.style.border = '2px solid #0c2a80';
        item.style.borderRadius = '20px';
      } else {
        item.style.border = '2px solid #ebebeb';
        item.style.borderRadius = '20px';
      }
    });
  }

  updateBorders();
  updateSizePrices();

  trigger.addEventListener('click', openDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  sizeItems.forEach(function (item) {
    var radio = item.querySelector('input[type="radio"]');

    item.addEventListener('click', function (e) {
      if (e.target === radio) return;

      if (radio && !radio.disabled) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));

        updateBorders();

        var sizeName = this.querySelector('.size-name');
        var dimensions = this.querySelector('.dimensions');
        var displayText = (sizeName ? sizeName.textContent : '') +
          ' ' + (dimensions ? dimensions.textContent : '');
        sizeDisplay.textContent = displayText.trim();

        setTimeout(closeDrawer, 300);
      }
    });

    if (radio) {
      radio.addEventListener('change', updateBorders);
    }

    var label = item.querySelector('.size-grid-label');
    if (label && !label.classList.contains('disabled')) {
      item.style.cursor = 'pointer';
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('active')) {
      closeDrawer();
    }
  });

  // Listen for changes on other option radios to update prices in real-time
  optionNames.forEach(function (name, index) {
    if (index === sizeOptionIndex) return;

    var handleName = name.toLowerCase().replace(/[^a-z0-9]+/g, '-');
    var radios = document.querySelectorAll('input[name="' + handleName + '"]');

    radios.forEach(function (radio) {
      radio.addEventListener('change', updateSizePrices);
    });
  });
})();
